module.exports = __webpack_public_path__ + "static/media/alcohol-and-addictions-large.50ebf378.png";